export default __webpack_public_path__ + "images/U8.8414739.png";